import { render, staticRenderFns } from "./fulltext-search.vue?vue&type=template&id=6028a804"
import script from "./fulltext-search.vue?vue&type=script&lang=js"
export * from "./fulltext-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports